import Breadcrumb from './src/breadcrumb.vue'

export default Breadcrumb
export * from './types'
